import { Semaphore } from './semaphore';

export class Mutex {
  #semaphore = new Semaphore(1);

  public constructor() {}

  public unlock() {
    this.#semaphore.unlock();
  }

  public lock() {
    return this.#semaphore.lock();
  }

  public isLocked() {
    return this.#semaphore.isLocked();
  }

  public getLockCount() {
    return this.#semaphore.getLockCount();
  }

  public getWaitCount() {
    return this.#semaphore.getWaitCount();
  }
  public async runExclusive<T>(fn: () => T): Promise<Awaited<T>> {
    return await this.#semaphore.runExclusive(fn);
  }
}
